var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4C1 1.79086 2.79086 0 5 0H7C7.55228 0 8 0.447715 8 1C8 1.55228 7.55228 2 7 2H5C3.89543 2 3 2.89543 3 4V6C3 6.55228 2.55228 7 2 7C1.44772 7 1 6.55228 1 6V4Z",
    fill: "#0F973D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4C21 1.79086 19.2091 0 17 0H15C14.4477 0 14 0.447715 14 1C14 1.55228 14.4477 2 15 2H17C18.1046 2 19 2.89543 19 4V6C19 6.55228 19.4477 7 20 7C20.5523 7 21 6.55228 21 6V4Z",
    fill: "#0F973D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20C2.79086 20 1 18.2091 1 16V14C1 13.4477 1.44772 13 2 13C2.55228 13 3 13.4477 3 14V16C3 17.1046 3.89543 18 5 18H7C7.55228 18 8 18.4477 8 19C8 19.5523 7.55228 20 7 20H5Z",
    fill: "#0F973D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16C21 18.2091 19.2091 20 17 20H15C14.4477 20 14 19.5523 14 19C14 18.4477 14.4477 18 15 18H17C18.1046 18 19 17.1046 19 16V14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14V16Z",
    fill: "#0F973D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12H21C21.5523 12 22 11.5523 22 11C22 10.4477 21.5523 10 21 10H1Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStep4);
export default __webpack_public_path__ + "static/media/ic_step4.aea6ec0bb50eb6e010005958e7299a2c.svg";
export { ForwardRef as ReactComponent };